import angular from 'angular';

export const CSV_FILE_EXTENSION = 'csv';

export const EmployerActivityReportService = ($filter, utils) => {

    const getCvsMetadata = (employerName) => {
        const columns = getCsvColumns();
        const headers = getCsvHeaders(columns);
        const footer = getCsvFooter();
        const fileName = getCsvName(employerName);

        return {
            columns,
            headers,
            fileName,
            footer
        };
    };

    const getCsvFooter = () => {
        return [
            '',
            'EMPLOYER_ACTIVITY_REPORT_JOBS_LEGEND',
            'EMPLOYER_ACTIVITY_REPORT_TPA_DESCRIPTION',
            'EMPLOYER_ACTIVITY_REPORT_REVIEWED_DESCRIPTION',
            'EMPLOYER_ACTIVITY_REPORT_SENT_FOR_FEEDBACK_DESCRIPTION',
            'EMPLOYER_ACTIVITY_REPORT_THUMB_UP_DESCRIPTION',
            'EMPLOYER_ACTIVITY_REPORT_THUMB_DOWN_DESCRIPTION',
            'EMPLOYER_ACTIVITY_REPORT_CONTACTED_DESCRIPTION',
            'EMPLOYER_ACTIVITY_REPORT_NO_RESPONSE_DESCRIPTION',
            'EMPLOYER_ACTIVITY_REPORT_INTEREST_DESCRIPTION',
            'EMPLOYER_ACTIVITY_REPORT_NO_INTEREST_DESCRIPTION',
            'EMPLOYER_ACTIVITY_REPORT_UNDECIDED_DESCRIPTION',
            'EMPLOYER_ACTIVITY_REPORT_QUALIFIED_DESCRIPTION',
            'EMPLOYER_ACTIVITY_REPORT_LIST_DESCRIPTION',
            'EMPLOYER_ACTIVITY_REPORT_COMMENTS_DESCRIPTION',
            '',
            'EMPLOYER_ACTIVITY_REPORT_NOTES',
            ''
        ];
    }

    const getCsvContent = (reports) => {
        const orderedReports = reports.sort((a,b)=> new Date(a.postedDate) - new Date(b.postedDate));
        const columns = getCsvColumns();
        const content = [];
        (orderedReports || []).forEach(item => {
            const result = [];
            const jobStatusTimeStamp = new Date(item['jobStatusTimeStamp']);
            jobStatusTimeStamp.setDate(jobStatusTimeStamp.getDate() + 30);
            const isMoreThan30daysAgo =  new Date() > jobStatusTimeStamp;
            const canSkip = ['Cancelled', 'Finished'].includes(item['jobStatus']) && isMoreThan30daysAgo;

            if (!canSkip) {
                columns.forEach(column => {
                    let value = item[column.key];
                    if (column.key === 'firstInsightReportDate' && value) {
                        value = 'SENT'
                    }

                    if (column.key === 'postedDate' && value) {
                        value = $filter('date')(value, 'MM/dd/yyyy')
                    }

                    if (column.key === 'locationCountry' && value) {
                        value = `${value},${item['locationCity']}`;
                    }

                    if (column.key === 'jobStatus' && value) {
                        if (value === 'Ready') {
                            value = 'Pending';
                        }
                        if (value === 'Cancelled') {
                            value = 'Closed';
                        }
                    }

                    const skipColumnValue = (column.key === 'employerContactCandidates') || (column.key === 'locationCity') ;

                    if (!skipColumnValue) {
                        result.push(value);
                    }
                });
                content.push(result);
            }
        });

        const translatedFooter = getCsvFooter().map(item =>{
            const arr = new Array(columns.length -1);
            const element = $filter('translate')(item);
            arr.unshift(element);
            return arr;
        });
        const fullContent = [...content, ...translatedFooter];

        return fullContent;
    };

    const getCsvColumns = () => {
        return [
            {'columnName':'EMPLOYER_ACTIVITY_REPORT_JOB_TITLE_COLUMN','key':'jobTitle'},
            {'columnName':'EMPLOYER_ACTIVITY_REPORT_JOB_LOCATION_COLUMN','key':'locationCountry'},
            {'columnName':'EMPLOYER_ACTIVITY_REPORT_JOB_STATUS_COLUMN','key':'jobStatus'},
            {'columnName':'EMPLOYER_ACTIVITY_REPORT_POSTED_DATE_COLUMN','key':'postedDate'},
            {'columnName':'EMPLOYER_ACTIVITY_REPORT_TPA_DATE_COLUMN','key':'firstInsightReportDate'},
            {'columnName':'EMPLOYER_ACTIVITY_REPORT_REVIEWED_COLUMN','key':'reviewedCountCandidates'},
            {'columnName':'EMPLOYER_ACTIVITY_REPORT_FEEDBACK_COUNT_COLUMN','key':'feedbackCount'},
            {'columnName':'EMPLOYER_ACTIVITY_REPORT_THUMB_UP_COLUMN','key':'feedbackPositive'},
            {'columnName':'EMPLOYER_ACTIVITY_REPORT_THUMB_DOWN_COLUMN','key':'feedbackNegative'},
            {'columnName':'EMPLOYER_ACTIVITY_REPORT_CONTACTED_COLUMN','key':'candidatesContacted'},
            {'columnName':'EMPLOYER_ACTIVITY_REPORT_CONTACTED_NO_RESPONSE_COLUMN','key':'candidatesContactedNoResponse'},
            {'columnName':'EMPLOYER_ACTIVITY_REPORT_INTERESTED_COLUMN','key':'candidatesInterested'},
            {'columnName':'EMPLOYER_ACTIVITY_REPORT_NO_INTERESTED_COLUMN','key':'candidatesNoInterest'},
            {'columnName':'EMPLOYER_ACTIVITY_REPORT_UNDECIDED_COLUMN','key':'candidatesUndecided'},
            {'columnName':'EMPLOYER_ACTIVITY_REPORT_QUALIFIED_COLUMN','key':'candidatesQualified'},
            {'columnName':'EMPLOYER_ACTIVITY_REPORT_LIST_COLUMN','key':'candidatesList'},
            {'columnName':'EMPLOYER_ACTIVITY_REPORT_COMMENT_COLUMN','key':''},
        ];
    };

    const getCsvHeaders = (csvColumns) => {
        return (csvColumns || []).map(({ columnName }) => $filter('translate')(columnName));
    };


    const getCsvName = (employerName) => {
        // eslint-disable-next-line no-undef
        const formatter = new Intl.DateTimeFormat('en-US', {
            year: 'numeric',
            month: 'short',
            day: 'numeric',
        });
        const formattedDate = formatter.format(new Date()).replace(',', '');
        const name = utils.joinTokens([employerName, 'Activity Report', formattedDate], ' - ');

        return `${name}.${CSV_FILE_EXTENSION}`;
    };

    return {
        getCsvContent,
        getCvsMetadata,
    };
};

angular
    .module('TALENYA-FE')
    .factory('EmployerActivityReportService', EmployerActivityReportService);